import { Link, NavLink } from "react-router-dom";
import { useEffect, useState } from "react";
import { Menu, X, Zap } from "lucide-react";

const links = [
  { to: "/", label: "Home", testid: "nav-home" },
  { to: "/models", label: "Models", testid: "nav-models" },
  { to: "/about", label: "About", testid: "nav-about" },
  { to: "/contact", label: "Contact", testid: "nav-contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-navbar"
      className={`sticky top-0 z-50 transition-all duration-300 ${
        scrolled
          ? "backdrop-blur-xl backdrop-saturate-150 bg-white/70 border-b border-white/60 shadow-[0_8px_32px_rgba(0,0,0,0.04)]"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
        <Link
          to="/"
          data-testid="nav-logo"
          className="flex items-center gap-2 group"
        >
          <span className="inline-flex h-8 w-8 items-center justify-center rounded-lg bg-emerald-500 text-white shadow-[0_0_20px_rgba(16,185,129,0.35)] transition-transform group-hover:rotate-6">
            <Zap className="h-4 w-4" strokeWidth={2.5} />
          </span>
          <span className="font-heading text-sm tracking-[0.22em] font-medium text-slate-950">
            ANANDSAHNI GREEN MOBILITY
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-1">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              data-testid={l.testid}
              className={({ isActive }) =>
                `relative px-4 py-2 text-sm font-medium transition-colors ${
                  isActive
                    ? "text-emerald-700"
                    : "text-slate-700 hover:text-slate-950"
                }`
              }
            >
              {({ isActive }) => (
                <>
                  {l.label}
                  {isActive && (
                    <span className="absolute left-4 right-4 -bottom-0.5 h-px bg-emerald-500" />
                  )}
                </>
              )}
            </NavLink>
          ))}
        </nav>

        <Link
          to="/models"
          data-testid="nav-cta-explore"
          className="hidden md:inline-flex items-center gap-2 rounded-full bg-slate-950 text-white text-xs font-medium px-5 py-2.5 hover:bg-emerald-600 transition-colors"
        >
          Explore lineup
          <span aria-hidden>→</span>
        </Link>

        <button
          type="button"
          aria-label="Open menu"
          data-testid="nav-mobile-toggle"
          className="md:hidden inline-flex h-10 w-10 items-center justify-center rounded-lg border border-slate-200 bg-white/70"
          onClick={() => setOpen((s) => !s)}
        >
          {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </button>
      </div>

      {open && (
        <div
          data-testid="nav-mobile-menu"
          className="md:hidden border-t border-white/60 bg-white/90 backdrop-blur-xl"
        >
          <div className="px-6 py-4 flex flex-col gap-1">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                data-testid={`${l.testid}-mobile`}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `px-3 py-2 rounded-md text-sm font-medium ${
                    isActive
                      ? "bg-emerald-50 text-emerald-700"
                      : "text-slate-800 hover:bg-slate-100"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}
